import { render } from "./CompetitionWizardAssistant.vue?vue&type=template&id=e285c008&scoped=true"
import script from "./CompetitionWizardAssistant.vue?vue&type=script&lang=js"
export * from "./CompetitionWizardAssistant.vue?vue&type=script&lang=js"

import "./CompetitionWizardAssistant.vue?vue&type=style&index=0&id=e285c008&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e285c008"]])

export default __exports__